import moment from 'moment';

export default class QmsEscalationMatrix {
  constructor({ id, key, isActive, matrix, updatedAt } = {}) {
    this.id = id || '';
    this.key = key || 'hr_management';
    this.isActive = !!isActive;
    this.matrix = Array.isArray(matrix) ? matrix : [];
    this.updatedAt = updatedAt ? moment(updatedAt).format('DD-MM-YYYY HH:mm') : '';
  }
}
